import request from "../request"
/**
 *  获取所有的权限
 * @method getAllPermission
 * @return {[type]}         [description]
 */

//查询招聘管理
export function sysJobList(form) {
    return request({
        url: `web/sysJob/front`,
        method: "get",
        params: form,
    })
}
